// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610160905/js/" + chunkId + "." + {"44":"d3debf2b","225":"294fa12e","481":"a37e40cf","486":"1c34a0d8","770":"5e5f38ef"}[chunkId] + ".0.2811805662911716.chunk.js";
};